
import { TFunction } from 'react-i18next'
import { z } from 'zod'

const tConfig = {
  ns: 'editPassword'
}

export const createSchema = (t: TFunction) => {
  // Regexp for password
  // Must contain 1 or more letters
  // Must contain 1 or more numbers
  // Must contain 1 or more special characters
  // Must be between 8 and 16 characters long
  const regex = /(?=(?:.*[a-zA-Z]){1,})(?=(?:.*[0-9]){1,})(?=(?:.*[@!$%^*${}]){1,})(^[a-zA-Z0-9@!$%^*${}]{8,16}$)/
  return z.object({
    password: z.string().min(1, t('validation.password.required', tConfig)).regex(regex, t('validation.password.pattern', tConfig)),
    confirm: z.string().min(1, t('validation.confirm.required', tConfig))
  })
    .refine((data) => data.password === data.confirm, {
      message: t('validation.confirm.match', tConfig),
      path: ['confirm']
    })
}

export type EditPasswordFormData = z.infer<ReturnType<typeof createSchema>>
